import { BaseResource } from '../core/base-resource';
import { ServiceName } from './service-name.enum';

export class SubscriptionsService extends BaseResource {
  serviceName: ServiceName;
  subscribed: boolean;
}
